<template>
  <div>
    <a-card title="参数设置" style="margin-bottom: 30px">
      <a-form-model :model="formRelevant.data" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" ref="ruleForm">
        <div style="padding-left: 30px">
          有效分数：
          <a-select v-model="formRelevant.data.scoreRangeType" style="width: 120px; margin-right: 20px" placeholder="请选择" :disabled="IsDetails">
            <a-select-option :value="0"> 单个任务 </a-select-option>
            <a-select-option :value="1"> 全部任务 </a-select-option>
          </a-select>
          <a-input-number :min="50" :max="150" placeholder="请输入最小值" :disabled="IsDetails" v-model="formRelevant.data.lowerEffectiveScore" style="width: 120px" />
          <span style="margin: 0 10px 20px">-</span>
          <a-input-number
            :min="formRelevant.data.lowerEffectiveScore ? formRelevant.data.lowerEffectiveScore + 1 : 50"
            :max="150"
            :disabled="IsDetails"
            placeholder="请输入最大值"
            v-model="formRelevant.data.upperEffectiveScore"
            style="width: 120px"
          />
          <span style="margin-left: 20px">( 请输入50-150的数字 )</span>
        </div>
        <div style="padding-left: 30px; margin-top: 30px">
          校正算法：
          <a-radio-group v-model="formRelevant.data.correctionMethod" :disabled="IsDetails">
            <a-radio :value="0">不校正</a-radio>
            <a-radio :value="1">系数校正</a-radio>
            <a-radio :value="2">标准差校正</a-radio>
          </a-radio-group>
        </div>
      </a-form-model>
    </a-card>
    <template v-if="reportInfo.reportType == 1">
      <a-card :class="{ examError: talentError }" v-if="((1 << 5) & reportInfo.reportModule) === 1 << 5" title="创新拔尖人才" style="margin-bottom: 12px">
        <div style="margin-bottom: 30px; padding-left: 30px">
          <div v-if="!IsDetails">
            <span>本次创新拔尖人才：</span>
            <span style="margin-right: 12px" v-if="talent">{{ talent.description }}</span>
            <a-button type="primary" @click="openUploadStudent">上传创新拔尖人才名单</a-button>
          </div>
          <div v-else-if="reportInfo.innovativeTalent" class="detail-wrapper">
            <!-- <div class="detail-title">本次创新拔尖人才：</div> -->
            <div class="detail-item">
              <div class="detail-item-label">创新拔尖人才描述：</div>
              <div class="detail-item-value">{{ reportInfo.innovativeTalent.description }}</div>
            </div>
            <div class="detail-item">
              <div class="detail-item-label">本校拔尖人才选择：</div>
              <div class="detail-item-value">
                {{ reportInfo.innovativeTalent.standard | filterStandard }}
              </div>
            </div>
          </div>
          <div v-if="!IsDetails" style="margin-top: 20px">
            <span>创新拔尖人才对比模板：</span>
            <a-button type="primary" @click="openCompareTemp">选择模板</a-button>
          </div>
          <div v-else-if="reportInfo.compareTemplates">
            <span>创新拔尖人才对比模板：</span>
            <span>{{ reportInfo.compareTemplates.join(',') }}</span>
          </div>
        </div>
      </a-card>
      <div v-if="talentError" class="examError-text" style="margin-bottom: 30px">{{ talentErrorMsg }}</div>
      <div v-else style="margin-bottom: 30px"></div>
      <a-card :class="{ examError: examError }" v-if="((1 << 4) & reportInfo.reportModule) === 1 << 4" title="潜力分析：选择学业成绩" style="margin-bottom: 12px">
        <div slot="extra" class="extra" v-if="tableRelevant.tableDataSource.length">
          <div>
            <a-tooltip>
              <template slot="title"> 相差名次越高，越难出现潜力较大</template>
              <a-icon type="question-circle" />
            </a-tooltip>
            <span class="extra-label">相差名次：</span>
            <a-input-number v-model="examConfig.rankingDifference" @blur="blurDifference" :disabled="IsDetails" :min="0" :max="9999" style="width: 120px" placeholder="" />
          </div>
          <div>
            <a-tooltip>
              <template slot="title">打开开关，在报告中展现单科成绩的潜力分析结果</template>
              <a-icon type="question-circle" />
            </a-tooltip>
            <span class="extra-label">单科成绩：</span>
            <a-switch checked-children="开" :disabled="IsDetails" @change="changeSwitch" v-model="examConfig.isSingleScoreOpen" un-checked-children="关" />
          </div>
        </div>
        <div style="margin-bottom: 30px; padding-left: 30px">
          <div v-if="!IsDetails" style="margin-bottom: 16px">
            <span style="margin-right: 12px">{{ reportInfo.organizationName }}</span>
            <a-button type="primary" @click="openUploadGrade" v-if="!tableRelevant.tableDataSource.length">选择成绩</a-button>
          </div>
          <div v-if="tableRelevant.tableDataSource.length">
            <a-table
              :pagination="tableRelevant.tablePagination"
              :loading="tableRelevant.tableLoading"
              :locale="tableRelevant.locale"
              :dataSource="tableRelevant.tableDataSource"
              :columns="columns"
              :scroll="{ y: 450 }"
            >
              <span slot="type" slot-scope="text">{{ text.type | filterExamType }} </span>
              <span slot="term" slot-scope="text">{{ text.term | filterTerm }} </span>
              <span slot="action" slot-scope="text">
                <a-popconfirm title="确认删除此考试？" @confirm="delExam(text)">
                  <a-button type="link" style="color: red">删除</a-button>
                </a-popconfirm>
                <a-button type="link" v-if="text.operatorId === user.id || isEdit" @click="onEdit(text)"> 编辑 </a-button>
              </span>
            </a-table>
          </div>
        </div>
      </a-card>
      <div v-if="examError" class="examError-text">潜力分析需选择学生学业成绩</div>
    </template>

    <div v-if="!IsDetails" style="text-align: right; margin: 30px 0; padding-right: 50px">
      <a-button @click="$parent.$data.current = 2" style="margin-right: 20px">上一步</a-button>
      <a-button type="primary" :loading="formRelevant.loading" @click="submit">生成报告</a-button>
    </div>
    <uploadStudent ref="uploadStudentRef" />
    <compareTemp ref="compareTempRef" />
    <selectGrade ref="selectGradeRef" />
    <uploadGrade ref="uploadGradeRef" />
    <uploadGradeSuccess ref="uploadGradeSuccessRef" />
  </div>
</template>

<script>
import $Bus from '@/pages/projectImpl/js/eventBus'
import { tableRelevant, FormatDate } from '@/pages/projectImpl/js/utils'
import uploadStudent from '../../components/uploadStudent.vue'
import compareTemp from '../../components/compareTemp.vue'
import selectGrade from '../../components/selectGrade.vue'
import uploadGrade from '../../components/uploadGrade.vue'
import uploadGradeSuccess from '../../components/uploadGradeSuccess.vue'
import { mapState } from 'vuex'

const standards = {
  1: '依据大脑学习力测评',
  2: '依据学校学业成绩',
  3: '依据学校分班',
}
const terms = {
  0: '其他',
  1: '上学期',
  2: '下学期',
}
const examType = {
  0: '普通小考',
  1: '期末考试',
  2: '期中考试',
  3: '中高考模拟考',
  4: '开学摸底考',
  5: '分班考试',
  6: '区域统考',
}
const columns = [
  { title: '考试名称', dataIndex: 'examName', key: 'examName', align: 'center' },
  { title: '考试学期', scopedSlots: { customRender: 'term' }, align: 'center' },
  { title: '考试类型', scopedSlots: { customRender: 'type' }, align: 'center' },
  { title: '学生数', dataIndex: 'studentCount', key: 'studentCount', width: 100, align: 'center' },
  { title: '参与潜力分析学生数', dataIndex: 'matchStudentCount', key: 'matchStudentCount', align: 'center' },
  { title: '考试时间', dataIndex: 'examTime', key: 'examTime', width: 180, align: 'center' },
  { title: '操作', scopedSlots: { customRender: 'action' } },
]
export default {
  name: 'StepsFourth',
  props: {
    IsDetails: false,
  },
  filters: {
    filterStandard(val) {
      return standards[val]
    },
    filterTerm(val) {
      return terms[val]
    },
    filterExamType(val) {
      return examType[val]
    },
  },
  components: { uploadStudent, compareTemp, selectGrade, uploadGrade, uploadGradeSuccess },
  data() {
    return {
      //当前报告信息
      examError: false,
      talentError: false,
      talentErrorMsg: '',
      reportInfo: this.$store.getters['organization/getReportInfo'],
      columns: [...columns],
      reportId: this.$store.getters['organization/getReportInfo'].id,
      talent: null,
      tableRelevant: tableRelevant.call(this),
      examConfig: {
        rankingDifference: 2,
        isSingleScoreOpen: false,
      },
      formRelevant: {
        loading: false,
        data: {
          lowerEffectiveScore: 50,
          upperEffectiveScore: 150,
          betterCount: 0,
          poorCount: 0,
          isGeneratePPT: false,
          correctionMethod: 1,
          scoreRangeType: 0,
          pupilExamId: undefined,
        },
      },
    }
  },
  computed: {
    ...mapState('account', ['permissions', 'user']),
    isEdit() {
      return this.$auth((_, __, permissions) => permissions.some((item) => item.operation && item.operation.indexOf('grade.edit') !== -1))
    },
  },
  created() {
    for (let key in this.formRelevant.data) {
      if (key === 'upperEffectiveScore' || key === 'lowerEffectiveScore') {
        this.formRelevant.data[key] = this.$store.getters['organization/getReportInfo'][key] || undefined
      } else {
        this.formRelevant.data[key] = this.$store.getters['organization/getReportInfo'][key]
      }
    }
    if (this.reportInfo.id) {
      this.getModel()
      // if (this.reportInfo.reportModule & 32 && !this.IsDetails) {
      //   this.getStudentGrade()
      // }
    }
    if (this.IsDetails) {
      this.columns.pop()
    }
  },
  methods: {
    blurDifference() {
      if (this._oldRankingDifference != this.examConfig.rankingDifference) {
        if (!this.examConfig.rankingDifference) {
          return (this.examConfig.rankingDifference = this._oldRankingDifference)
        }
        this.updateGroupExamConfig()
        this._oldRankingDifference = this.examConfig.rankingDifference
      }
    },
    changeSwitch() {
      this.updateGroupExamConfig()
    },
    async openUploadGrade() {
      const { isSuccess, data, message } = await this.$refs['selectGradeRef'].showModal({ groupReportId: this.reportInfo.id, organizationId: this.reportInfo.orgId }).catch(async (data) => {
        if (data && data.errorData) {
          await this.handlerError(data)
        }
      })
      if (isSuccess) {
        this.onUploadSuccess({ data, message })
      }
    },
    async handlerError(error) {
      if (!error.errorData?.some((v) => v.errorStudent.length)) {
        error.message = '测评人数小于30人，未满足潜力分析最小人数要求。'
        error.evalError = true
        await this.$refs['uploadGradeSuccessRef'].showModal({ matchErrorMsg: error.message, evalError: error.evalError })
      }
      await this.$refs['uploadGradeRef'].showModal({ matchErrorMsg: error.message, matchError: error.errorData, id: error.examId, exam: error.exam, noMsg: true })
      const params = {
        groupReportId: this.reportInfo.id,
        examId: error.examId,
      }
      const { data, isSuccess, message } = await this.$http.ReportService.chooseReportExam(params, { message: false }).catch((err) => err)
      if (!isSuccess) {
        if (data) {
          error.errorData = data
          error.message = message
          await this.handlerError(error)
        } else {
          this.$message.error(message)
        }
      } else {
        this.onUploadSuccess({ data, message })
      }
    },
    async openCompareTemp() {
      const { templateIds } = await this.$refs['compareTempRef'].showModal({ groupReportId: this.reportInfo.id, templateIds: this.talent.templateIds })
      this.talent.templateIds = templateIds
      if (this.talent.description) {
        this.talentError = false
        this.talentErrorMsg = ''
      }
    },
    async openUploadStudent() {
      const form = await this.$refs['uploadStudentRef'].showModal({ groupReportId: this.reportInfo.id, record: this.talent })
      form.templateIds = this.talent.templateIds
      this.talent = form
      if (this.talent.templateIds?.length) {
        this.talentError = false
        this.talentErrorMsg = ''
      }
    },
    //根据id获取团体报告信息
    getModel() {
      this.$http.ReportService.getGroupByCId(this.reportId).then(async (res) => {
        const { data } = res
        for (let key in this.formRelevant.data) {
          if (['lowerEffectiveScore', 'upperEffectiveScore'].includes(key)) {
            this.formRelevant.data[key] = data[key] || undefined
            continue
          }
          this.formRelevant.data[key] = data[key]
        }
        this.reportInfo.reportDate = data.reportDate
        this.reportInfo.reportModule = data.reportModule
        this.reportInfo.period = data.period
        if (data.groupExam) {
          this.tableRelevant.tableDataSource = [{ ...data.groupExam, matchStudentCount: data.matchStudentCount }]
        }
        const innovativeTalent = (this.reportInfo.innovativeTalent = data.innovativeTalent)
        this.talent = {}
        if (innovativeTalent) {
          this.talent.description = innovativeTalent.description
          this.talent.standard = innovativeTalent.standard
        }
        const groupExam = data.groupExam
        if (groupExam) {
          this.examConfig.rankingDifference = data.rankingDifference
          this._oldRankingDifference = this.examConfig.rankingDifference
          this.examConfig.isSingleScoreOpen = data.isSingleScoreOpen
        }

        this.$set(this.reportInfo, 'compareTemplates', [])
        if (innovativeTalent) {
          const templateIds = innovativeTalent.templateIds
          this.talent.templateIds = templateIds || []
          if (templateIds && templateIds.length) {
            this.reportInfo.compareTemplates = await this.getTemplates(templateIds)
          }
        }

        this.$emit('reportData', this.reportInfo)
      })
    },
    async getTemplates(templateIds) {
      const params = {
        pageIndex: 1,
        pageSize: 99,
      }
      const results = []
      const { data } = await this.$http.GroupReportTemp.getList(params).finally(() => (this.tableRelevant.tableLoading = false))
      const items = data.items
      items.forEach((item) => {
        if (templateIds.includes(item.id)) {
          results.push(item.name)
        }
      })

      return results
    },
    async delExam(record) {
      await this.$http.ReportService.deleteReportExam({ id: this.reportInfo.id })
      this.$message.success('操作成功')
      this.tableRelevant.tableDataSource = []
      this.examConfig.isSingleScoreOpen = false
      this.examConfig.rankingDifference = 2
    },
    async updateGroupExamConfig(init) {
      if (!init) {
        if (!this.tableRelevant.tableDataSource.length || !(this.reportInfo.reportModule & 16)) {
          return Promise.resolve()
        }
      }
      const params = {
        groupReportId: this.reportInfo.id,
        ...this.examConfig,
      }
      return this.$http.ReportService.updateGroupExamConfig(params)
    },
    async submit() {
      if (((1 << 5) & this.reportInfo.reportModule) === 1 << 5) {
        if (!this.talent.description && this.talent.description !== 0) {
          this.talentErrorMsg = '创新拔尖人才需按照模板上传学生'
          return (this.talentError = true)
        }
        if (!this.talent.templateIds?.length) {
          this.talentErrorMsg = '请选择创新拔尖人才对比模板'
          return (this.talentError = true)
        }
      }

      if (((1 << 4) & this.reportInfo.reportModule) === 1 << 4 && !this.tableRelevant.tableDataSource.length) {
        return (this.examError = true)
      }
      const form = {
        lowerEffectiveScore: this.formRelevant.data.lowerEffectiveScore || 50,
        upperEffectiveScore: this.formRelevant.data.upperEffectiveScore || 150,
        betterCount: this.formRelevant.data.betterCount || 0,
        poorCount: this.formRelevant.data.poorCount || 0,
        pupilExamId: this.formRelevant.data.pupilExamId,
        scoreRangeType: this.formRelevant.data.scoreRangeType || 0,
        isGeneratePPT: this.formRelevant.data.isGeneratePPT,
        correctionMethod: this.formRelevant.data.correctionMethod,
        studentSampleTakingMethod: this.reportInfo.studentSampleTakingMethod,
        id: this.reportInfo.id,
        nameCN: this.reportInfo.nameCN,
        nameEN: this.reportInfo.nameEN,
        projectName: this.reportInfo.projectName,
        reportTime: this.reportInfo.reportTime,
        reportDate: this.reportInfo.reportDate,
        projectCourseConfigId: this.reportInfo.projectCourseConfigId || undefined,
        reportType: this.reportInfo.reportType,
        reportModule: this.reportInfo.reportModule,
        userCourseStatus: this.reportInfo.userCourseStatus,
        isContainContentScore: this.reportInfo.isContainContentScore,
        status: 2,
        contrastDimension: this.reportInfo.contrastDimension,
        analyzeGranularity: this.reportInfo.analyzeGranularity,
        createReportTime: FormatDate(Date.now(), 'YYYY-MM-DD hh:mm:ss'),
        wordReportUrl: '',
        pdfReportUrl: '',
        pptUrl: '',
        name: this.reportInfo.name,
        period:this.reportInfo.period
      }
      this.formRelevant.loading = true
      await Promise.all([this.$http.ReportService.editGroupReport(form)]).finally(() => (this.formRelevant.loading = false))
      await this.$http.ReportService.genGroupReport(this.reportInfo.id).finally(() => (this.formRelevant.loading = false))
      this.$message.success('操作成功')
      this._submit = true
      $Bus.$emit('closeCreateReport')
    },
    async onUploadSuccess({ data, message }) {
      await this.$refs['uploadGradeSuccessRef'].showModal({ matchData: data, message }).finally(() => this.getModel())
      this.examError = false
    },
    async onEdit(record) {
      const options = {
        id: record.id,
        organizationId: this.reportInfo.orgId,
        exam: { ...record },
      }
      const { file } = await this.$refs['uploadGradeRef'].showModal(options)
      const params = {
        groupReportId: this.reportInfo.id,
        examId: record.id,
      }
      if (file) {
        const { data, isSuccess, message } = await this.$http.ReportService.chooseReportExam(params, { message: false }).catch((err) => err)
        if (!isSuccess) {
          if (data) {
            const error = { message: message, errorData: data, examId: record.id, exam: { ...record } }
            await this.handlerError(error)
          }
        } else {
          this.onUploadSuccess({ data, message })
        }
      } else {
        this.onUploadSuccess({ data, message })
      }
    },
  },
}
</script>

<style scoped>
.age {
  margin-top: 15px;
  margin-bottom: 0;
}

.age /deep/ .ant-form-item {
  width: 50%;
  height: 60px;
  margin-bottom: 0;
}

.age-cont {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.exam {
  padding: 2px 30px 2px 10px;
  background: #f1f1f1;
  border-radius: 4px;
  margin-right: 20px;
  position: relative;
}
.exicon {
  position: absolute;
  top: 7px;
  right: 8px;
  font-size: 10px;
  cursor: pointer;
}
.noClose {
  cursor: no-drop;
}
.extra {
  display: flex;
  align-items: center;
  gap: 12px;
}
.extra ::v-deep .ant-input-number:hover .ant-input-number-handler-wrap {
  display: none;
}
.extra-label {
  margin-left: 4px;
}
.extra > div {
  display: flex;
  align-items: center;
}
.examError {
  border: 1px solid red;
  border-radius: 8px;
}
.examError-text {
  color: red;
}
.detail-wrapper {
  display: flex;
  margin-bottom: 20px;
}
.detail-item {
  margin-right: 32px;
  max-width: 500px;
  display: flex;
}
.detail-item-label {
  width: 140px;
  flex-shrink: 0;
}
.detail-item-value {
  flex: 1;
  word-break: break-all;
}
</style>
